import { Card, Empty, Tag } from 'antd'
import { RobotOutlined } from '@ant-design/icons'
import { MdViewer } from '@/components/MarkdownFile'
import type { StockFinancialData } from '@/types/stockPool'

interface Props {
    financials: StockFinancialData[]
}

export default function AIResearchTab({ financials }: Props) {
    const latest = financials[0] ?? null

    if (!latest) {
        return (
            <div className="new-kb-tab ai-research-tab">
                <Empty description="暂无财务分析数据" image={Empty.PRESENTED_IMAGE_SIMPLE} />
            </div>
        )
    }

    const analysis = latest.indicators_step_2_md ?? ''
    const period = [latest.fiscal_year, latest.report_date].filter(Boolean).join(' ')

    return (
        <div className="new-kb-tab ai-research-tab">
            <Card
                size="small"
                className="new-kb-card"
                title={
                    <span className="ai-card-title">
                        <RobotOutlined style={{ marginRight: 6, color: '#1677ff' }} />
                        AI 财务分析
                    </span>
                }
                extra={period ? <Tag color="blue">{period}</Tag> : null}
            >
                {analysis ? (
                    <div className="ai-analysis-body">
                        <MdViewer content={analysis} />
                    </div>
                ) : (
                    <Empty description="该期财报暂无 AI 分析内容" image={Empty.PRESENTED_IMAGE_SIMPLE} style={{ padding: '16px 0' }} />
                )}
            </Card>

            {financials.length > 1 && (
                <Card title="历史分析期次" size="small" className="new-kb-card">
                    <div className="history-periods">
                        {financials.slice(1, 6).map((d, i) => (
                            <div key={i} className="history-period-item">
                                <span className="history-period-label">
                                    {d.fiscal_year ?? d.closing_date?.slice(0, 7) ?? '--'}
                                </span>
                                <span className="history-period-status">
                                    {d.indicators_step_2_md ? '已分析' : '无分析'}
                                </span>
                            </div>
                        ))}
                    </div>
                </Card>
            )}
        </div>
    )
}
